module.exports = __webpack_public_path__ + "media/images/logo_rexit_career-a28f02c348d8556c61356fc6d1995c84.svg";